import React from 'react';
import { Alert, Snackbar, Button, Box, Typography } from '@mui/material';
import { Update, Refresh } from '@mui/icons-material';
import { useServiceWorker } from 'src/hooks/useOffline';

const UpdateAvailableBanner: React.FC = () => {
  const { updateAvailable, updateServiceWorker } = useServiceWorker();

  if (!updateAvailable) return null;

  return (
    <Snackbar
      open={updateAvailable}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ mb: 2 }}
    >
      <Alert
        severity="info"
        icon={<Update />}
        action={
          <Button
            color="inherit"
            size="small"
            startIcon={<Refresh />}
            onClick={updateServiceWorker}
          >
            Update
          </Button>
        }
        sx={{ width: '100%' }}
      >
        <Box>
          <Typography variant="body2" fontWeight={600}>
            Update Available
          </Typography>
          <Typography variant="caption">
            A new version of Telix Lab is available. Click Update to refresh.
          </Typography>
        </Box>
      </Alert>
    </Snackbar>
  );
};

export default UpdateAvailableBanner;

